import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import { createClient } from '../lib/apollo';
import { LoginPage } from '../auth/pages/LoginPage';
import { Dashboard } from '../components/dashboard/Dashboard';
import { Provider } from 'react-redux';
import { store } from './store';
import { SWRConfig } from 'swr';

const App: React.FunctionComponent = () => {

  return (
    <React.StrictMode>
      <Provider store={store}>
        <IntlProvider locale={'fr'}>
          <ApolloProvider client={createClient()}>
            <SWRConfig value={{
              dedupingInterval: 600000,
              revalidateIfStale: true,
              revalidateOnFocus: false}} >
            <Router>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/*" element={<Dashboard />} />
              </Routes>
            </Router>
            </SWRConfig>
          </ApolloProvider>
        </IntlProvider>
      </Provider>
    </React.StrictMode>
  );
};

export default App;
